function pxToRem(number) {
  return `${number / 16}rem`;
}

function rgba(color, opacity) {
  if (!color) return `rgba(0, 0, 0, ${opacity})`;

  if (color.startsWith("rgb")) {
    const values = color
      .replace(/[^\d,]/g, "")
      .split(",")
      .map((v) => v.trim());

    if (values.length >= 3) {
      return `rgba(${values[0]}, ${values[1]}, ${values[2]}, ${opacity})`;
    }
  }

  let hex = color.replace("#", "");

  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((char) => char + char)
      .join("");
  }

  if (hex.length !== 6) {
    return color;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

function linearGradient(color1, color2) {
  return `linear-gradient(195deg, ${color1}, ${color2})`;
}

function boxShadow(offset = [0, 2], radius = [0, 0], color = "#000", opacity = 0.15, inset = "") {
  const [x, y] = offset;
  const [blur, spread] = radius;
  return `${inset} ${pxToRem(x)} ${pxToRem(y)} ${pxToRem(blur)} ${pxToRem(spread)} ${rgba(
    color,
    opacity
  )}`.trim();
}

export default {
  pxToRem,
  rgba,
  linearGradient,
  boxShadow,
};
